<template>
	<div class="component-navigator-bar-menu overflow-hidden" :class="[theme]">
		<div class="bm-row bm-gx-6 hidden bmxl:flex">
			<div
				class="flex-grow-0 bm-col"
				:class="{ 'padding-none': !item.show }"
				v-for="item in commonRoutes"
				:key="item.value"
			>
				<SensorTrack :datas="item.sensorData" v-if="item.show && item.type === 'single'">
					<nuxt-link-enhance
						class="item flex items-center whitespace-nowrap cursor-pointer hover:bm-text-effect"
						:class="[size]"
						:project="item.project"
						:to="item.to"
						exact
					>
						<svg
							class="svgfont relative mr-1"
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
							width="512"
							height="512"
							viewBox="0 0 512 512"
							v-if="item.hot"
						>
							<path
								fill="#fa772d"
								d="M218.297 16c44.778 34.983 76.093 68.925 93.944 101.857 16.909 31.202 23.695 63.121 20.365 95.756l-0.647 5.44 3.318-2.712c11.904-10.229 21.079-23.254 26.704-37.906l1.462-4.034 4.174-12.536c44.654 30.331 66.986 81.701 66.986 154.099 0 108.589-95.152 177.909-173.351 177.909-78.218 0-167.256-46.452-181.662-143.671-14.393-97.204 45.299-142.588 85.96-205.905 27.126-42.207 44.695-84.977 52.749-128.293z"
							/>
							<path
								fill="#faac2d"
								d="M215.646 128.016c34.599 26.939 58.793 53.077 72.583 78.435 13.063 24.028 18.31 48.606 15.734 73.739l-0.5 4.185 2.563-2.089c9.197-7.875 16.286-17.906 20.632-29.19l1.132-3.107 3.226-9.654c34.499 23.359 51.754 62.916 51.754 118.666 0 83.618-73.517 136.999-133.94 136.999-60.43 0-129.225-35.772-140.356-110.635-11.12-74.851 35-109.801 66.416-158.559 20.958-32.501 34.532-65.436 40.755-98.792z"
							/>
						</svg>
						<span>{{ getTranslate(item.nameLangList, item.name) }}</span>

						<span
							class="bm-bg-effect-trans bm-text-effect font-medium rounded text-xs h-4 leading-4 px-1 ml-[2px]"
							v-if="item.label"
						>
							<!-- 部分情况下，name不存在，但label存在，算是别名 -->
							{{ $t(item.label) }}
						</span>
					</nuxt-link-enhance>
				</SensorTrack>
				<DropdownMenuPicker
					:size="size"
					:width="item.columns ? '648px' : '324px'"
					:reference="getTranslate(item.nameLangList, item.name)"
					:hot="item.hot"
					:columns="item.columns"
					:list="item.list"
					@select="onSelect($event)"
					v-if="item.show && item.type === 'group'"
				>
					<template v-if="item.iconName === 'menu'" #default>
						<MenuIcon />
					</template>
				</DropdownMenuPicker>
			</div>
		</div>
	</div>
</template>

<script>
import Cookies from 'js-cookie';
import _get from 'lodash/get';
import commonMixins from '../mixins';
import SensorTrack from './SensorTrack';
import DropdownMenuPicker from './DropdownMenuPicker';
import NuxtLinkEnhance from './NuxtLinkEnhance';
import { PROJECT_MAP } from '@/frontend-shared/components/NavigatorBar/config';
import MenuIcon from '../assets/menu.svg?inline';
import { usePatchStore } from '~/common/js/patch';
import i18nMessage from '../i18n';

export default {
	name: 'ComponentNavigatorBarMenu',
	components: {
		DropdownMenuPicker,
		NuxtLinkEnhance,
		SensorTrack,
		MenuIcon,
	},

	mixins: [commonMixins],
	props: {
		size: {
			type: String,
			default: 'normal',
		},
		theme: {
			type: String,
			default: 'light',
		},
		project: {
			type: String,
			default: PROJECT_MAP.MASTER,
		},
		commonRoutesConfig: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	data() {
		return {};
	},
	computed: {
		locale() {
			return this.store.locale;
		},
		futuresType() {
			return this.store.account.futuresType;
		},
		commonRoutes() {
			return this.project === PROJECT_MAP.DERIVATIVES ? this.$$FUTURES_ROUTES_CONFIG : this.commonRoutesConfig;
		},
	},

	methods: {
		onSelect(item) {
			// @TODO 这个地方需要提取代码，不然耦合性太强
			// 如果是trade，则额外做处理
			// @TODO 换成Map.get的取值
			if (['trade.advanced', 'trade.standard'].includes(item.value)) {
				// @TODO 这里会有一些额外的处理
				Cookies.set('tradeType', item.to?.query?.layout, {
					httpOnly: false,
					secure: import.meta.env.VITE_DEBUG !== 'true',
					sameSite: 'Lax',
				});
			} else if (['trade.futures_coin'].includes(item.value)) {
				this.commit('SET_COINTYPE', 'COIN');
			} else if (['trade.futures_usdt'].includes(item.value)) {
				this.commit('SET_COINTYPE', 'USD');
			}
		},
		getTranslate(langList, defaultValue) {
			const i18nExist = _get(i18nMessage?.[this.$$locale], defaultValue);

			let val = '';
			if (langList?.[this.$$transRouteLocale]) {
				val = langList?.[this.$$transRouteLocale];
			} else if (i18nExist) {
				val = defaultValue;
			} else {
				val = langList?.['en-US'] || defaultValue;
			}

			return val ? this.$t(val) : val;
		},
	},
	setup() {
		const { store, commit } = usePatchStore();
		return {
			store,
			commit,
		};
	},
};
</script>

<style lang="less" scoped>
@import '../assets/css/ui.variables.less';

.component-navigator-bar-menu {
	.item {
		height: @navigator_bar_height;
		&.small {
			height: @navigator_bar_height_small;
		}
		&.medium {
			height: @navigator_bar_height_medium;
		}
	}

	.padding-none {
		padding-left: 0;
		padding-right: 0;
	}
}
</style>
